import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const AppRefreshContext = createContext({
  refreshKey: 0,
  bumpRefresh: () => {},
});

export function AppRefreshProvider({ children }) {
  const [refreshKey, setRefreshKey] = useState(0);

  const bumpRefresh = useCallback(() => {
    setRefreshKey(k => k + 1);
  }, []);

  const value = useMemo(() => ({ refreshKey, bumpRefresh }), [refreshKey, bumpRefresh]);

  return <AppRefreshContext.Provider value={value}>{children}</AppRefreshContext.Provider>;
}

export function useAppRefresh() {
  return useContext(AppRefreshContext);
}
